import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { INTEGRATION_CONFIG_SELECT_FIELD_OPTIONS_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_integration_config_select_field_options_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';

import { SelectOption } from '@/types/integrations.ts';

export type OptionResponse = {
  options: SelectOption[];
};

const useRetrieveSelectFieldOptionsIntegrations = (
  stepId: string,
  fieldId: string,
  enabled: boolean,
): UseQueryResult<SelectOption[], AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: INTEGRATION_CONFIG_SELECT_FIELD_OPTIONS_KEY(automationId, stepId, fieldId),
    queryFn: async () => {
      const response = await apiClient.get<OptionResponse>(
        get_integration_config_select_field_options_url(automationId, stepId, fieldId),
      );
      return response.data.options;
    },
    enabled: !!automationId && enabled,
  });
};

export default useRetrieveSelectFieldOptionsIntegrations;
